import React from 'react';
import { EmptyState } from '@scale/scaleui';

export const StartSearchCard = () => {
  return (
    <EmptyState
      className="bg-utility-white rounded-xl"
      icon="search"
      title="Add some queries to start searching resumes"
      description=""
    />
  );
};
